export enum DeleteReason {
  DEFAULT,
  LEGAL_TO_SELL
}

export interface IAPIResponse {
  images: IImagesItem[];
  color: string;
  product: IProduct;
  mainImageId: number | null;
  optionId: number;
}

export interface IImagesItem {
  id: number;
  product_id: string;
  option_id: null | string;
  image_url: string;
  is_background_light: null | boolean;
  does_contain_text: null | boolean;
  parent_image_id: null | string;
  fallback_image_id: null | string;
  created_at: string;
  updated_at: string;
  option_value: null | string;
  type: string;
}

export interface IProduct {
  id: number;
  source_name: string;
  source_description: string;
  source_url: string;
  source_options: null;
  source_items_sold: string;
  source_items_sold_update: null;
  created_at: string;
  updated_at: string;
  deleted_at: null;
  brand_id: string;
  viewed: string;
  google_id: null | string;
  blacklisted: null;
  google_exclude: string;
  is_draft: boolean;
  cat_check: string;
  missing_picture: string;
  contentUpdate: string;
  contentUpdateDate: null | string;
  priceUpdate: string;
  priceUpdateDate: null;
  resetCounter: string;
  resetDate: string;
  is_checked_after_ali_pulling: boolean;
}



// WEBPACK FOOTER //
// ./src/api/types.ts